export const AI_FEEDBACK_ASSET_TYPES = {
  AUDIT: 'AUDIT',
  TRACING: 'TRACING',
  CERTIFICATE: 'CERTIFICATE',
  CERTIFIED_MATERIALS: 'CERTIFIED_MATERIALS',
  CAP: 'CAP',
  //add more as needed
} as const;

export type AiFeedbackAssetType =
  (typeof AI_FEEDBACK_ASSET_TYPES)[keyof typeof AI_FEEDBACK_ASSET_TYPES];

export const AI_FEEDBACK_ASSET_TYPE_VALUES = Object.values(
  AI_FEEDBACK_ASSET_TYPES,
) as [AiFeedbackAssetType, ...AiFeedbackAssetType[]];

export const AI_FEEDBACK_PROCESS_TYPES = {
  EXTRACTION: 'EXTRACTION',
  CLASSIFICATION: 'CLASSIFICATION',
  FIELD_EXTRACTION: 'FIELD_EXTRACTION',
  CERTIFICATE_WORKFLOW: 'CERTIFICATE_WORKFLOW',
  //add more as needed
} as const;

export type AiFeedbackProcessType =
  (typeof AI_FEEDBACK_PROCESS_TYPES)[keyof typeof AI_FEEDBACK_PROCESS_TYPES];

export const AI_FEEDBACK_PROCESS_TYPE_VALUES = Object.values(
  AI_FEEDBACK_PROCESS_TYPES,
) as [AiFeedbackProcessType, ...AiFeedbackProcessType[]];
